export default __webpack_public_path__ + "static/media/Glove0.81226929.svg";